import slug from 'slug'
import type {Ref} from "vue";
export default function () {
    const sluga = (code: string) => {
        return slug(code).toUpperCase()
    }

    const truncate = (value: string, len: number, om: string = '') => {
        let append = om ? om.toString() : '...';
        if (value.length <= len || typeof value === 'number') {
            return value;
        } else {
            return value.substring(0, len) + append;
        }
    }

    const formatDate = (date: any, trimTime = false) => {
        if (!date) return ''

        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        } as const;

        if (trimTime)
            return new Date(date).toLocaleDateString('ru-Ru', options)
        else
            return new Date(date).toLocaleString('ru-Ru', {...options, hour12: false})

    }

    const formatDateStr = (date: string) => {
        if (!date) return ''

        const [y,m,d] = date.split('-')

        return `${y}.${m}.${d}`
    }

    const addZero = (x: number) => {
        if (x < 10) return `0${x}`
        else return x
    }

    const htmlDate = (date: Date) => {
        return `${date.getFullYear()}-${addZero(date.getMonth()+1)}-${addZero(date.getDate())}`
    }

    const getHttpMethod = (id: number|undefined|null) => {
        return id == null ? 'POST' : 'PATCH'
    }

    const setFocus = (focusable: Ref) => {
        setTimeout(() => {
            focusable.value?.setFocus()
        }, 350)
    }

    const genderToString = (code: string|null): string => {
        switch(code) {
            case 'm': return 'Мужской'
            case 'f': return 'Женский'
            default: return ''
        }
    }

    return {sluga, truncate, formatDate, htmlDate, getHttpMethod, setFocus, formatDateStr, genderToString}
}
